import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails"
import "yet-another-react-lightbox/plugins/thumbnails.css"

type GalleryImage = {
  id: number
  url: string
  description?: string | null
}

type Props = {
  images: GalleryImage[]
  index: number | null
  onClose: () => void
}

export function GalleryLightbox({ images, index, onClose }: Props) {
  return (
    <Lightbox
      open={index !== null}
      close={onClose}
      index={index ?? 0}
      slides={images.map((image) => ({ src: image.url, alt: image.description || undefined }))}
      plugins={[Zoom, Thumbnails]}
    />
  )
}
